/**
 * blob下载
 * @export
 * @param {response} 返回请求体
 * @returns
 */
export function blobDownload (response) {
  const blob = new Blob([response.data], {type: 'application/octet-stream'})
  // 有可能会应为域名不同，获取不到content-disposition
  const filename = response.headers['content-disposition'].split(';')[1].split('filename=')[1]
  if ('msSaveOrOpenBlob' in navigator) {
    // Microsoft Edge and Microsoft Internet Explorer 10-11
    window.navigator.msSaveOrOpenBlob(blob, decodeURIComponent(filename))
  } else {
    // standard code for Google Chrome, Mozilla Firefox etc
    const href = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = href
    link.download = decodeURIComponent(filename)
    link.click()
  }
}



// WEBPACK FOOTER //
// ./src/utils/blob-download.js